import { render, staticRenderFns } from "./ContactPropertyListTable.vue?vue&type=template&id=3a068f2c&"
import script from "./ContactPropertyListTable.vue?vue&type=script&lang=js&"
export * from "./ContactPropertyListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports